export default __webpack_public_path__ + "static/media/yahoonews1.1ee73a69.PNG";